import { FileDocumentAlertOutlineIcon } from './FileDocumentAlertOutlineIcon';

/**
 * author: Simran
 * id CF5F798F-BB0B-4F5A-98C4-3CFADF57BAA3
 * name file-document-alert-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-alert-outline.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileTextAlertOutlineIcon = FileDocumentAlertOutlineIcon;
export default FileTextAlertOutlineIcon